import React, { Component } from "react";
import Grid from "@react/react-spectrum/Grid/js/Grid";
import GridColumn from "@react/react-spectrum/Grid/js/GridColumn";
import GridRow from "@react/react-spectrum/Grid/js/GridRow";
import Well from "@react/react-spectrum/Well";
import DataSection from "../../comps/DataSection/DataSection";
import formFields from "../config/formFields";
import Button from "@react/react-spectrum/Button";
import Link from "@react/react-spectrum/Link";
import Dialog from "@react/react-spectrum/Dialog";
import Heading from "@react/react-spectrum/Heading";
import { Translate } from "react-redux-i18n";
import Wait from "@react/react-spectrum/Wait";
import { Provider, connect } from "react-redux";
import { getFormValues, reduxForm } from "redux-form";
import "../managePage.css";
import Rule from "@react/react-spectrum/Rule";
import store from "../../store";

import ContactDisplay from "../singleUseComps/contactsDisplay.jsx";
import throwError, { toastPartnerApiFailure } from "../../comps/errorToast";
import { normalizeApiErrorMessages } from "../../components/errors";

//Laguage Selector
import { disableLanguageSelectorToggle } from "../../actions/commonActions";
import { setLocaleWithFallback } from "../../actions/index";
import { preferredLanguageName } from "../../i18n/config";
// // import geoPolData from '../../registration/config/geoPolData.js';

import { hideLinksForSpecifiedCountry, isRestrictedSanctionCountry } from "../utils/utils.js";
import { getContractDates } from "../../utils/contractDates";
// TODO(sanctions-ru-by): RU/BY banner + disabled actions — SANCTIONS_RU_BY_VALIDATION_ENABLED
import RestrictedCountryBanner from "../../components/RestrictedCountryBanner";

class PrimaryContact extends Component {
  constructor() {
    super();
    window.scrollTo(0, 0);
    this.state = {
      sectionValidation: {},
      popupValidation: {},
      popupMode: null,
      formInitialized: false,
    };
  }

  componentDidMount() {
    let initFields = {};
    if (this.props.partnerData) {
      initFields = {
        ...this.props.partnerData.partnerInfo,
        ...this.getGeo(this.props.partnerData.partnerInfo.billingCountry),
        specializationInfo: this.props.partnerData.specializationInfo,
        ...getContractDates(
          this.props.partnerData.partnerInfo.anniversaryDate,
          this.props.partnerData.partnerInfo.contractStartDate,
        ),
      };
    }
    if (
      this.props.partnerData.contactInfo &&
      this.props.partnerData.contactInfo.preferredLanguage
    ) {
      this.setLang(this.props.partnerData.contactInfo.preferredLanguage);
    }
    initFields["companyType"] = initFields["companyType"]?.split(";");
    this.props.initialize(initFields);
    this.setState({ formInitialized: true });
  }

  setLang = (lang) => {
    const finalLocale = Object.keys(preferredLanguageName).includes(lang)
      ? preferredLanguageName[lang]
      : "en_US";
    store.dispatch(setLocaleWithFallback(finalLocale));
    store.dispatch(disableLanguageSelectorToggle(true));
  };

  getGeo = (billingCountry) => {
    let retObj = { geo: "" };
    Object.keys(this.props.geoPolData).map((key) => {
      let obj = this.props.geoPolData[key];
      if (obj.countries.hasOwnProperty(billingCountry)) {
        retObj.geo = obj.value;
      }
      return null;
    });
    return retObj;
  };

  updateValidation = (name, value) => {
    let sectionValidation = this.state.sectionValidation;
    sectionValidation[name] = value;
    this.setState({ sectionValidation: sectionValidation });
  };

  onEditProfileButtonClick = () => {
    let resetData = {};
    formFields.eap_section1.map((obj) => {
      resetData[obj.name] =
        this.props.formStates[obj.name] !== undefined
          ? this.props.formStates[obj.name]
          : null;
    });
    formFields.eap_section2.map((obj) => {
      resetData[obj.name] =
        this.props.formStates[obj.name] !== undefined
          ? this.props.formStates[obj.name]
          : null;
    });
    this.setState({ resetData: resetData, popupMode: "editAccountProfile" });
  };

  onEditProfileSave() {
    let body = {};
    formFields.eap_section1.map((obj) => {
      body[obj.name] = this.props.formStates[obj.name];
    });
    formFields.eap_section2.map((obj) => {
      body[obj.name] = this.props.formStates[obj.name];
    });
    body["companyType"] = body["companyType"].join(";");
    body = { partnerInfo: body };
    this.props.isSavingToggle(true);
    this.props.connector.updatePartnerInfo(
      this.onEditProfileSaveComplete,
      body,
      this.props.formStates["accountId"],
    );
  }

  onEditProfileCancel = () => {
    formFields.eap_section1.map((obj) => {
      this.props.change(obj.name, this.state.resetData[obj.name]);
    });
    formFields.eap_section2.map((obj) => {
      this.props.change(obj.name, this.state.resetData[obj.name]);
    });
    this.setState({ popupMode: null });
  };

  onEditProfileSaveComplete = (response = {}) => {
    if (response?.isError) {
      toastPartnerApiFailure(response);
    } else {
      this.setState({ popupMode: null });
    }
    this.props.isSavingToggle(false);
  };

  popupValidation = (name, value) => {
    let popupValidation = this.state.popupValidation;
    popupValidation[name] = value;
    this.setState({ popupValidation: popupValidation });
    // this.forceUpdate();
  };

  onFileDownloadComplete = async (response = {}, downloadFor) => {
    if (response?.isError) {
      if (normalizeApiErrorMessages(response).length > 0) {
        toastPartnerApiFailure(response);
      } else {
        throwError(
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <span>
              We apologize for the inconvenience. It seems there is an issue
              accessing the requested link at this time. We recommend attempting
              again shortly.
            </span>

            <span>
              If the issue continues, please reach out to the Adobe Partner
              Connection Help Desk at
              <a
                href="https://cbconnection.adobe.com/en/apc-helpdesk"
                style={{ margin: "0px 5px", color: "#fff" }}
                target="_blank"
              >
                https://cbconnection.adobe.com/en/apc-helpdesk
              </a>{" "}
              for dedicated support.
            </span>
          </div>,
          30000,
        );
      }
      this.setState({ popupMode: null });
    } else {
      let fileName = "file.pdf";
      if (downloadFor && downloadFor === "c2a") {
        fileName = `C2A.pdf`;
      }

      if (downloadFor && downloadFor === "education") {
        fileName = `Education.pdf`;
      }

      if (downloadFor && downloadFor === "government") {
        fileName = `Government.pdf`;
      }

      try {
        const blob = new Blob([response?.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        throwError(
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <span>
              We apologize for the inconvenience. It seems there is an issue
              accessing the requested link at this time. We recommend attempting
              again shortly.
            </span>

            <span>
              If the issue continues, please reach out to the Adobe Partner
              Connection Help Desk at
              <a
                href="https://cbconnection.adobe.com/en/apc-helpdesk"
                style={{ margin: "0px 5px", color: "#fff" }}
                target="_blank"
              >
                https://cbconnection.adobe.com/en/apc-helpdesk
              </a>{" "}
              for dedicated support.
            </span>
          </div>,
          30000,
        );
      } finally {
        this.setState({ popupMode: null });
      }
    }
  };

  onFileDownload = (e, downloadFor) => {
    e.preventDefault();
    this.setState({ popupMode: "fileDownload" });
    this.props.connector.downloadFile(
      this.onFileDownloadComplete,
      this.props.formStates["accountId"],
      downloadFor,
    );
  };

  render() {
    const formName = "managePartnership";
    let RULE = (
      <GridRow>
        <GridColumn size={[12, 12, 12, 12]}>
          <Rule className="rule" variant="small" />
        </GridColumn>
      </GridRow>
    );

    const shouldLinksBeHidden = hideLinksForSpecifiedCountry(
      this.props?.formStates?.billingCountry,
    );
    const isSanctionRestricted = isRestrictedSanctionCountry(
      this.props?.partnerData?.partnerInfo?.billingCountry,
    );

    return (
      <div>
        {this.state.formInitialized ? (
          <div>
            {this.state.popupMode ? (
              <div className="overlay" style={{ zIndex: "2" }}>
                <Wait size="L" centered />
              </div>
            ) : null}
            <div className="page-head">
              <Heading
                style={{
                  paddingLeft: "2%",
                  color: "white",
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
                variant="pageTitle"
              >
                <Translate value="managePartnership.page_heading_prim" />
              </Heading>
            </div>

            <div className="page-banner">
              <div className="center">
                <Heading style={{ fontSize: "28px" }}>
                  <Translate value="managePartnership.ConsolePartnerHeader" />
                </Heading>
                <Link
                  style={{ fontSize: "16px" }}
                  href={window.apcConfig.partner.home}
                >
                  <Translate value="managePartnership.go_to_home_page" />
                </Link>
              </div>
            </div>

            <Grid>
              <RestrictedCountryBanner visible={isSanctionRestricted} />
              <GridRow>
                <GridColumn size={[12, 10, 10, 8]} offsetSize={[0, 1, 1, 2]}>
                  <GridRow>
                    <GridColumn>
                      <Heading className="section-heading" variant="subtitle1">
                        <Translate value="managePartnership.ConsolePartnerRegistrationHeader" />
                      </Heading>
                    </GridColumn>
                  </GridRow>
                  <Well className="well-white">
                    <GridRow>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          field={formFields.page1_section1}
                          mode="nonEditable"
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="page1_section1"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          field={formFields.page1_section2}
                          mode="nonEditable"
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="page1_section2"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                  </Well>

                  <br />
                  <br />
                  <GridRow>
                    <GridColumn>
                      <Heading className="section-heading" variant="subtitle1">
                        <Translate value="managePartnership.ConsolePartnerAccountHeader" />
                      </Heading>
                    </GridColumn>
                    <GridColumn>
                      <Button
                        className="button-action margin-action"
                        variant="cta"
                        disabled={isSanctionRestricted}
                        onClick={() => {
                          this.onEditProfileButtonClick();
                        }}
                      >
                        <Translate value="managePartnership.ConsolePartnerBtnEditProfile" />
                      </Button>
                      {this.state.popupMode === "editAccountProfile" ? (
                        <Dialog
                          className="customDialog"
                          variant="confirmation"
                          title={
                            <Translate value="managePartnership.ConsolePartnerBtnEditProfile" />
                          }
                          confirmLabel={
                            <Translate value="managePartnership.TrngSaveClose" />
                          }
                          onConfirm={() => {
                            this.onEditProfileSave();
                          }}
                          onCancel={() => {
                            this.onEditProfileCancel();
                          }}
                          confirmDisabled={
                            !Object.values(this.state.popupValidation).every(
                              Boolean,
                            )
                          }
                          cancelLabel={
                            <Translate value="managePartnership.TrngClose" />
                          }
                        >
                          <Provider store={store}>
                            <GridRow>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <DataSection
                                  field={formFields.eap_section1}
                                  sectionName="eap_section1"
                                  formStates={this.props.formStates}
                                  form={formName}
                                  updateValidation={this.popupValidation}
                                />
                              </GridColumn>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <DataSection
                                  field={formFields.eap_section2}
                                  sectionName="eap_section2"
                                  formStates={this.props.formStates}
                                  form={formName}
                                  updateValidation={this.popupValidation}
                                />
                              </GridColumn>
                            </GridRow>
                          </Provider>
                        </Dialog>
                      ) : null}
                    </GridColumn>
                  </GridRow>

                  <Well className="well-white">
                    <GridRow>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          field={formFields.eap_section1}
                          sectionName="eap_section1"
                          mode="nonEditable"
                          formStates={this.props.formStates}
                          form={formName}
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          field={formFields.eap_section2}
                          sectionName="eap_section2"
                          mode="nonEditable"
                          formStates={this.props.formStates}
                          form={formName}
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                  </Well>

                  <br />
                  <br />

                  <ContactDisplay
                    setLang={this.setLang}
                    {...this.props}
                    isRestrictedSanctionCountry={isSanctionRestricted}
                  />
                  {Boolean(
                    this.props.formStates.level !== "Registered" &&
                    this.props.partnerData.contactInfo &&
                    this.props.partnerData.contactInfo.mainContactType ===
                      "Primary",
                  ) ? (
                    <div>
                      <GridRow>
                        <GridColumn>
                          <Heading
                            className="section-heading"
                            variant="subtitle1"
                          >
                            <Translate value="managePartnership.ConsolePartnerSplznLinkHeader" />
                          </Heading>
                        </GridColumn>
                      </GridRow>
                      <GridRow>
                        <GridColumn size={[12, 6, 6, 6]}>
                          <Well className="well-white">
                            <div>{RULE}</div>
                            <GridRow>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <span>Commercial</span>
                              </GridColumn>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <span>
                                  {
                                    <Translate value="managePartnership.ConsolePartnerConActive" />
                                  }
                                </span>
                              </GridColumn>
                            </GridRow>

                            {this.props.formStates.level !==
                              "Services Bundle Provider" &&
                            Boolean(this.props.formStates.specializationInfo) &&
                            this.props.formStates.specializationInfo
                              .education &&
                            !shouldLinksBeHidden ? (
                              <div>
                                <div>{RULE}</div>
                                <GridRow>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    <span> Education</span>
                                  </GridColumn>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    {isSanctionRestricted ? (
                                      <span className="disabled-link">
                                        Apply/renew
                                      </span>
                                    ) : (
                                      <Link
                                        href={
                                          window.apcConfig.partner
                                            .specialization +
                                          "specialization/?type=education"
                                        }
                                        target="_blank"
                                      >
                                        Apply/renew
                                      </Link>
                                    )}
                                  </GridColumn>
                                </GridRow>
                              </div>
                            ) : null}

                            {this.props.formStates.level !==
                              "Services Bundle Provider" &&
                            Boolean(this.props.formStates.specializationInfo) &&
                            this.props.formStates.specializationInfo
                              .government &&
                            !shouldLinksBeHidden ? (
                              <div>
                                <div>{RULE}</div>
                                <GridRow>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    <span>Government</span>
                                  </GridColumn>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    {isSanctionRestricted ? (
                                      <span className="disabled-link">
                                        Apply/renew
                                      </span>
                                    ) : (
                                      <Link
                                        href={
                                          window.apcConfig.partner
                                            .specialization +
                                          "specialization/?type=government"
                                        }
                                        target="_blank"
                                      >
                                        Apply/renew
                                      </Link>
                                    )}
                                  </GridColumn>
                                </GridRow>
                              </div>
                            ) : null}

                            <div>{RULE}</div>
                          </Well>
                        </GridColumn>
                      </GridRow>
                    </div>
                  ) : null}

                  {Boolean(
                    this.props.formStates.level !== "Registered" &&
                    this.props.partnerData.contactInfo &&
                    this.props.partnerData.contactInfo.mainContactType ===
                      "Primary",
                  ) ? (
                    <div>
                      <GridRow>
                        <GridColumn>
                          <Heading
                            className="section-heading"
                            variant="subtitle1"
                          >
                            <Translate value="Download File" />
                          </Heading>
                        </GridColumn>
                      </GridRow>
                      <GridRow>
                        <GridColumn size={[12, 6, 6, 6]}>
                          <Well className="well-white">
                            <div>{RULE}</div>
                            <GridRow>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <span>Clickthrough Agreement </span>
                              </GridColumn>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <Link
                                  href="#"
                                  target="_blank"
                                  onClick={(e) => this.onFileDownload(e, "c2a")}
                                >
                                  Download PDF
                                </Link>
                              </GridColumn>
                            </GridRow>

                            {this.props.formStates.level !==
                              "Services Bundle Provider" &&
                            Boolean(this.props.formStates.specializationInfo) &&
                            this.props.formStates.specializationInfo
                              .education &&
                            !shouldLinksBeHidden ? (
                              <div>
                                <div>{RULE}</div>
                                <GridRow>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    <span> Education</span>
                                  </GridColumn>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    <Link
                                      href="#"
                                      target="_blank"
                                      onClick={(e) =>
                                        this.onFileDownload(e, "education")
                                      }
                                    >
                                      Download PDF
                                    </Link>
                                  </GridColumn>
                                </GridRow>
                              </div>
                            ) : null}

                            {this.props.formStates.level !==
                              "Services Bundle Provider" &&
                            Boolean(this.props.formStates.specializationInfo) &&
                            this.props.formStates.specializationInfo
                              .government &&
                            !shouldLinksBeHidden ? (
                              <div>
                                <div>{RULE}</div>
                                <GridRow>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    <span>Government</span>
                                  </GridColumn>
                                  <GridColumn size={[12, 6, 6, 6]}>
                                    <Link
                                      href="#"
                                      target="_blank"
                                      onClick={(e) =>
                                        this.onFileDownload(e, "government")
                                      }
                                    >
                                      Download PDF
                                    </Link>
                                  </GridColumn>
                                </GridRow>
                              </div>
                            ) : null}

                            <div>{RULE}</div>
                          </Well>
                        </GridColumn>
                      </GridRow>
                    </div>
                  ) : null}
                </GridColumn>
              </GridRow>
            </Grid>
          </div>
        ) : (
          <Wait size="L" centered />
        )}
      </div>
    );
  }
}

PrimaryContact = reduxForm({
  form: "managePartnership",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PrimaryContact);

function mapStateToProps(state) {
  return {
    geoPolData: state.common.geoPolData,
    formStates: getFormValues("managePartnership")(state),
  };
}

export default connect(mapStateToProps)(PrimaryContact);
